import React from 'react';

export interface IconSearchProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconSearch: React.FC<IconSearchProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path fillRule="evenodd" clipRule="evenodd" d="M10.8739 2.25C8.58647 2.25 6.39269 3.15869 4.7752 4.77618C3.15772 6.39366 2.24902 8.58744 2.24902 10.8749C2.24902 13.1624 3.15772 15.3562 4.7752 16.9736C6.39269 18.5911 8.58647 19.4998 10.8739 19.4998C12.9101 19.4998 14.8721 18.7798 16.4194 17.4808L20.4687 21.5301L20.9991 22.0605L22.0597 20.9998L21.5294 20.4695L17.48 16.4201C18.7789 14.8728 19.4988 12.911 19.4988 10.8749C19.4988 8.58744 18.5902 6.39366 16.9727 4.77618C15.3552 3.15869 13.1614 2.25 10.8739 2.25ZM5.83585 5.83683C7.17203 4.50064 8.98429 3.74998 10.8739 3.74998C12.7636 3.74998 14.5758 4.50064 15.912 5.83683C17.2482 7.17301 17.9989 8.98526 17.9989 10.8749C17.9989 12.7646 17.2482 14.5768 15.912 15.913C14.5758 17.2492 12.7636 17.9998 10.8739 17.9998C8.98429 17.9998 7.17203 17.2492 5.83585 15.913C4.49967 14.5768 3.74901 12.7646 3.74901 10.8749C3.74901 8.98526 4.49967 7.17301 5.83585 5.83683Z" fill={fill || "#020617"} />  
    </svg>
  );
};

export default IconSearch;
